( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const numberOfPages = $( '.gform_page' ).length;
        if ( numberOfPages == currentPage ) {
          $( 'body' ).addClass( 'mpf__show-last-page-image' );
        } else {
          $( 'body' ).removeClass( 'mpf__show-last-page-image' );
        }

        if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
          $( 'input[type=\'file\']' ).change( function() {
            const fullPath = $( this ).val();
            let filename = fullPath.replace( /^.*[\\/]/, '' );
            if ( filename === '' ) {
              filename = 'No file chosen';
            }
            const theInput = $( this ).parent().find( '.ll-file-upload span.ll-file-details' );
            $( theInput ).text( filename );
          } );
        }
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.gform_confirmation_message .btn-primary' ).each( function() {
          const text = $( this ).text().trim();
          $( this ).empty().append( '<span class="button-wrapper"><span class="icon-wrapper"><svg class="icon icon-arrow-right" aria-hidden="true"><use xlink:href="#icon-arrow-right"></use></svg></span></span>' + text );
        } );
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( 'body' ).removeClass( 'mpf__show-last-page-image' );
        const confirmationMessage = $( '.gform_confirmation_message' ).html();
        $( '#mpf__confirmation-message' ).html( confirmationMessage );
        $( '.gform_confirmation_message' ).addClass( 'hidden' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
